export enum EWildWheelFeatureEvents {
    WILD_WHEEL_START_$ = 'WILD_WHEEL_START_$',
    WILD_WHEEL_SPIN_$ = 'WILD_WHEEL_SPIN_$',
    WILD_WHEEL_RESULT_$ = 'WILD_WHEEL_RESULT_$',
    WILD_WHEEL_END_$ = 'WILD_WHEEL_END_$'
}
